import axios from 'axios';
import { BuddiResponse } from '../types';

const BUDDI_BASE_URL = 'https://buddi.bentley.com/WebService';

let defaultRegion = '1';
const cachedUrls: { [name: string]: string } = {};

export const initializeBuddi = async (
  names: string[],
  region: string
): Promise<void> => {
  setDefaultRegion(region);
  await Promise.all(names.map(async name => getUrl(name)));
};

export const getUrl = async (
  name: string,
  region?: string | number
): Promise<string | undefined> => {
  if (cachedUrls[name]) return cachedUrls[name];

  const response = (
    await axios.get<BuddiResponse>(
      `${BUDDI_BASE_URL}/GetURL?url=${name}&region=${region || defaultRegion}`
    )
  ).data;

  if (response.resultInfo.resultCount < 1) {
    throw new Error(`BUDDI error: ${response.resultInfo.message}`);
  }

  cachedUrls[name] = response.result.url;
  return response.result.url;
};

export const setDefaultRegion = (region: string) => (defaultRegion = region);
